export default {
  BT_HDP: "핸디캡 | 핸디캡",
  BT_OU: "오버/언더 | 오버/언더",
  BT_ML: "머니라인",
  BT_1X2: "1X2",
  BT_1X2HDP: "3방식 핸디캡",
  BT_CS: "정확한 득점",
  BT_OE: "홀수/짝수 | 홀수/짝수",
  BT_DC: "더블 찬스",
  BT_HTFT: "전반전 경기/전후반경기",
  BT_FGLG: "첫 골/마지막 골",
  BT_TG: "총 득점",
  BT_OR: "승자 예상 배팅",
  BT_ORZ: "승자 예상 배팅",

  BT_ANB: "Away No Bet",
  BT_BS: "양 팀 득점/한 팀 득점/득점 없음",
  BT_CL: "클린 시트",
  BT_DNB: "무승부 시 베팅 무효",
  BT_DNBH: "전후반경기 무승부 시 베팅 무효",
  BT_HNB: "Home No Bet",
  BT_TWTN: "완봉승",

  BT_HDPF: "풀타임 핸디캡 | 풀타임 핸디캡",
  BT_OUF: "풀타임 오버/언더 | 풀타임 오버/언더",
  BT_MLF: "전후반경기 머니라인",
  BT_1X2F: "풀타임 1X2",
  BT_1X2HDPF: "전후반경기 3방식 핸디캡",
  BT_CSF: "전후반경기 정확한 득점",
  BT_OEF: "전후반경기 홀수/짝수",
  BT_DCF: "전후반경기 더블 찬스",
  BT_FGLGF: "전후반경기 첫 골 /마지막 골",
  BT_TGF: "전후반경기 총 득점",

  BT_HDPH: "전반전 핸디캡 | 전반전 핸디캡",
  BT_OUH: "전반전 오버/언더 | 전반전 오버/언더",
  BT_MLH: "전반전 머니라인",
  BT_1X2H: "전반전 1X2",
  BT_1X2HDPH: "전반전 3방식 핸디캡",
  BT_CSH: "전반전 정확한 득점",
  BT_OEH: "전반전 홀수/짝수",
  BT_DCH: "전반전 더블 찬스",
  BT_FGLGH: "전반전 첫 골 /마지막 골",
  BT_TGH: "전반전 총 득점",
  BT_O: "오버",
  BT_U: "언더",
  BT_ODD: "홀수",
  BT_EVEN: "짝수",

  BT_HDPOU: "핸디캡&오버/언더",
  BT_PARLAY: "믹스 팔레이",
  BT_FT: "전후반경기. ",
  BT_1H: "전반전. ",
  BT_2H: "후반전. ",

  BT_FG: "첫 득점",
  BT_LG: "마지막 득점",
  BT_HFG: "홈팀첫골",
  BT_AFG: "원정팀첫골",
  BT_HLG: "홈팀마지막골",
  BT_ALG: "원정팀마지막골",
  BT_NG: "노 골",
  BT_HY: "홈 팀 예스",
  BT_HN: "홈 팀 노",
  BT_AY: "원정팀 예스",
  BT_AN: "원정팀 노",
  BT_H: "홈팀",
  BT_A: "원정팀",
  BT_D: "무승부",
  BT_HD_DC: "홈 혹은 무승부",
  BT_HA_DC: "홈 혹은 원정",
  BT_DA_DC: "원정팀 혹은 무승부",
  BT_HH: "홈/홈",
  BT_HD: "홈/무승부",
  BT_HA: "홈/원정팀",
  BT_DH: "무승부/홈",
  BT_DD: "무승부/무승부",
  BT_DA: "무승부/원정팀",
  BT_AH: "원정팀/홈",
  BT_AD: "원정팀/무승부",
  BT_AA: "원정팀/원정팀",

  BT_Y: "예스",
  BT_N: "노",

  BT_LIVE: "라이브",
  BT_HT: "H.TIME",
  BT_DELAYED: "지연",
  BT_PEN: "PEN",

  BT_FT1: "풀타임.1",
  BT_FT2: "풀타임.2",
  BT_FTX: "풀타임.X",
  BT_HT1: "전반전.1",
  BT_HT2: "전반전.2",
  BT_HTX: "전반전.X",

  BT_BOTH: "양팀",
  BT_ONE: "한팀",

  BS_HDP: "풀타임 핸디캡",
  BS_HDPH: "전반전 핸디캡",
  BS_OU: "풀타임 오버/언더",
  BS_OUH: "전반전 오버/언더",
  BS_OE: "전후반경기 홀수/짝수",
  BS_OEH: "전반전 홀수/짝수",
  BS_1X2: "풀타임 1X2",
  BS_1X2H: "전반전 1X2",
  BS_ML: "전후반경기 머니라인",
  BS_MLH: "전반전 머니라인",
  BS_1X2HDP: "전후반경기 3방식 핸디캡",
  BS_1X2HDPH: "전반전 3방식 핸디캡",
  BS_CS: "전후반경기 정확한 득점",
  BS_CSH: "전반전 정확한 득점",
  BS_DC: "전후반경기 더블 찬스",
  BS_DCH: "전반전 더블 찬스",
  BS_FGLG: "전후반경기 첫 골 /마지막 골",
  BS_FGLGH: "전반전 첫 골 /마지막 골",
  BS_TG: "전후반경기 총 득점",
  BS_TGH: "전반전 총 득점",
  BS_ANB: "Away No Bet",
  BS_HTFT: "전반전 경기/전후반경기",
  BS_BS: "양 팀 득점/한 팀 득점/득점 없음",
  BS_CL: "클린 시트",
  BS_DNB: "무승부 시 베팅 무효",
  BS_DNBH: "전후반경기 무승부 시 베팅 무효",
  BS_HNB: "Home No Bet",
  BS_TWTN: "완봉승",
  BS_OR: "승자 예상 배팅",
  BS_ORZ: "승자 예상 배팅",

  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "모든 베팅 종류",

  D_1: "단일 번호",
  D_2: "번호 & 리버스",
  D_3: "박스",
  D_4: "i박스",
  D_5: "마지막 3자리 박스",
  D_6: "마지막 2자리 박스",

  D_BIG: "빅",
  D_SMALL: "스몰",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "KO 방식",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "승리",
  GH_1X20: "승리",
  GH_1X2HDP: "복승/삼복",
  GH_1X2HDP2: "복승",
  GH_1X2HDP4: "삼복",
  GH_OVER: "오버 (4,5,6)",
  GH_UNDER: "언더 (1,2,3)",
  GH_ODD: "홀수 (1,3,5)",
  GH_EVEN: "짝수 (2,4,6)",
  GH_OU1: "오버 (4,5,6)",
  GH_OU2: "언더 (1,2,3)",
  GH_OE1: "홀수 (1,3,5)",
  GH_OE2: "짝수 (2,4,6)",

  GX_1X2: "승리",
  GX_1X20: "승리",
  GX_1X2HDP: "복승/삼복",
  GX_1X2HDP2: "복승",
  GX_1X2HDP4: "삼복",
  GX_OVER: "오버 (7-12)",
  GX_UNDER: "언더 (1-6)",
  GX_ODD: "홀수 (1,3,5,7,9,11)",
  GX_EVEN: "짝수 (2,4,6,8,10,12)",
  GX_OU1: "오버 (7-12)",
  GX_OU2: "언더 (1-6)",
  GX_OE1: "홀수 (1,3,5,7,9,11)",
  GX_OE2: "짝수 (2,4,6,8,10,12)",

  GC_OU: "오버/언더",
  GC_OE: "홀/짝",
  GC_OVER: "오버 (3,4,5)",
  GC_UNDER: "언더 (0,1,2)",
  GC_ODD: "홀수 (1,3,5)",
  GC_EVEN: "짝수 (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "첫 번째 공",
  GC_1X20: "승리 예측",
  GC_ML: "첫 번째 공",
  GC_1X2: "승리 예측",
  GC_OU1: "오버 (3,4,5)",
  GC_OU2: "언더 (0,1,2)",
  GC_OE1: "홀수 (1,3,5)",
  GC_OE2: "짝수 (0,2,4)",

  ROOM_A: "오픈",
  ROOM_0: "진행 중",
  ROOM_1: "마감",
  ROOM_2: "취소",
  ROOM_3: "종료됨",
  ROOM_4: "베팅 중지",
  ROOM_10: "전체",

  ROOM_T0: "전체",
  ROOM_T1: "공개방",
  ROOM_T2: "비공개방",
  ROOM_T3: "플레이투언",

  joinRoom1: "공개방 참여",
  joinRoom2: "비공개방 참여",
  joinRoom3: "플레이방 참여",
  createRoom1: "공개방 생성",
  createRoom2: "비공개방 생성",
  createRoom3: "플레이방 생성",
  Champion: "챔피언",
  FirstRunnerUp: "준우승",
  SecondRunnerUp: "3위",

  BT_OEHM: "홈 홀/짝 | 홈 홀/짝",
  BT_OEHMH: "전반전 홈 홀/짝 | 전반전 홈 홀/짝",
  BT_OEAW: "원정 홀/짝 | 원정 홀/짝",
  BT_OEAWH: "전반전 원정 홀/짝 | 전반전 원정 홀/짝",

  BS_OEHM: "전체전 홈 홀/짝 | 전체전 홈 홀/짝",
  BS_OEHMH: "전반전 홈 홀/짝 | 전반전 홈 홀/짝",
  BS_OEAW: "전체전 원정 홀/짝 | 전체전 원정 홀/짝",
  BS_OEAWH: "전반전 원정 홀/짝 | 전반전 원정 홀/짝",

  MB_OVER: "오버 (4,5,6)",
  MB_UNDER: "언더 (1,2,3)",
  MB_ODD: "홀수 (1,3,5)",
  MB_EVEN: "짝수 (2,4,6)",

  BS_1X2OU: "1X2 + 오버/언더",
  BT_1X2OU: "1X2 + 오버/언더",
  BT_1O: "1 오버",
  BT_1U: "1 언더",
  BT_2O: "2 오버",
  BT_2U: "2 언더",
  BT_XO: "무 오버",
  BT_XU: "무 언더",

  BS_DCOU: "더블찬스 + 오버/언더",
  BT_DCOU: "더블찬스 + 오버/언더",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "오버/언더 + 홀/짝",
  BT_OUOE: "오버/언더 + 홀/짝",
  BK_OO: "오버/홀",
  BK_OE: "오버/짝",
  BK_UO: "언더/홀",
  BK_UE: "언더/짝",

  BS_HTFTOE: "전반/전체 + 홀/짝",
  BT_HTFTOE: "전반/전체 + 홀/짝",
  BK_EO: "짝/홀",
  BK_EE: "짝/짝",

  BS_WM: "승리 마진",
  BT_WM: "승리 마진",
  BK_H1: "홈 1점차",
  BK_H2: "홈 2점차",
  BK_H3Up: "홈 3점 이상",
  BK_A1: "원정 1점차",
  BK_A2: "원정 2점차",
  BK_A3Up: "원정 3점 이상",
  BK_D: "무승부 (0-0 제외)",
  BK_NG: "무득점",

  BS_ETG: "정확한 총 득점",
  BT_ETG: "정확한 총 득점",
  BS_EHTG: "정확한 홈 득점",
  BT_EHTG: "정확한 홈 득점",
  BS_EATG: "정확한 원정 득점",
  BT_EATG: "정확한 원정 득점",
  BS_ETGH: "전반전 정확한 총 득점",
  BT_ETGH: "전반전 정확한 총 득점",
  BS_EHTGH: "전반전 정확한 홈 득점",
  BT_EHTGH: "전반전 정확한 홈 득점",
  BS_EATGH: "전반전 정확한 원정 득점",
  BT_EATGH: "전반전 정확한 원정 득점",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6 이상",
  BT_3Up: "3 이상",

  BT_CSHTFT: "전후반 점수",
  BS_CSHTFT: "전후반 점수",
  BT_ETGHTFT: "전후반 총골",
  BS_ETGHTFT: "전후반 총골",

  CF_CS_2_1: "2-1",
  CF_CS_2_0: "2-0",
  CF_CS_0_2: "0-2",
  CF_CS_1_2: "1-2",
  CF_R_1_W: "1라운드 승자",
  CF_R_2_W: "2라운드 승자",
  CF_R_3_W: "3라운드 승자",
  CF_MLHOME: "홈팀 승리",
  CF_MLAWAY: "원정팀 승리",
  CF_EVEN: "2회전 경기",
  CF_ODD: "3회전 경기",
  CF_ML1: "홈팀 승리",
  CF_ML2: "원정팀 승리",
  CF_ML: "단독 승리",
  CF_CS: "정확한 스코어",
  CF_OE: "홀수/짝수",
  CF_0: "무승부",
  CF_1: "홈",
  CF_2: "원정",
  CF_OE1: "홀수",
  CF_OE2: "짝수",

  MA_CS_3_0: "3-0",
  MA_CS_2_1: "2-1",
  MA_CS_0_3: "0-3",
  MA_CS_1_2: "1-2",
  MA_ML_TW: "팀 승리",
  MA_O: "오버",
  MA_U: "언더",
  MA_OE1: "홀수",
  MA_OE2: "짝수",
  MA_ML: "머니 라인",
  MA_CS: "정확한 스코어",
  MA_OU: "오버/언더",
  MA_OE: "홀수/짝수",
  MA_R_1_W: "1라운드 승자",
  MA_R_2_W: "2라운드 승자",
  MA_R_3_W: "3라운드 승자",
  MA_T_3_R: "총 3라운드 결과",
  MA_ANY_W_R: "어떤 라운드든 승리",
  MA_NO_W_R: "어떤 라운드도 승리하지 못함",
  MA_W_1: "1승",
  MA_W_2: "2승",
  MA_PF: "퍼펙트",
  MA_OU1: "오버",
  MA_OU2: "언더",
  MA_ML1: "홈 승리",
  MA_ML2: "원정 승리",
  MA_ML_C_1: "어떤 라운드든 승리",
  MA_ML_C_2: "어떤 라운드도 승리하지 못함",
  
  EF8_R1_1STBOOM: "1라운드 첫 번째 붐",
  EF8_R2_1STBOOM: "2라운드 첫 번째 붐",
  EF8_R3_1STBOOM: "3라운드 첫 번째 붐",
  EF8_0: "-",
  EF8_1: "홈",
  EF8_2: "원정",

};